import React from "react";

const PrimaryButton = ({
  children,
  label,
  className = "fp-ai-btn fp-ai-btn--request",
  loading = false,
  type = "button",
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={loading || props.disabled}
      className={className}
      {...props}
    >
      {loading ? "Submitting..." : label || children}
    </button>
  );
};

export default PrimaryButton;
